export default "__VITE_ASSET__C8G228m$__"